import type { FontSizes, ContainerStyles } from './BaseCardTypes';

export const getFontSizes = (highlight: boolean): FontSizes => ({
  position: highlight ? "var(--font-size-lg)" : "var(--font-size-base)",
  title: highlight ? "var(--font-size-3xl)" : "var(--font-size-2xl)",
  score: highlight ? "var(--font-size-5xl)" : "var(--font-size-4xl)",
  indexText: highlight ? "var(--font-size-base)" : "var(--font-size-sm)",
  button: highlight ? "var(--font-size-base)" : "var(--font-size-sm)",
  category: highlight ? "var(--font-size-base)" : "var(--font-size-sm)",
  listItem: highlight ? "var(--font-size-sm)" : "var(--font-size-xs)",
});

export const getContainerStyles = (highlight: boolean): ContainerStyles => ({
  height: highlight ? "500px" : "450px",
  paddingTop: highlight ? "var(--spacing-2)" : "var(--spacing-2)",
  paddingBottom: highlight ? "var(--spacing-2)" : "var(--spacing-2)",
  paddingLeft: "var(--spacing-2)",
  paddingRight: "var(--spacing-2)",
});

export const getTitleHeight = (highlight: boolean): string => {
  return highlight
    ? "calc(var(--font-size-3xl) * var(--line-height-tight) * 2)"
    : "calc(var(--font-size-2xl) * var(--line-height-tight) * 2)";
};

export const darkenColor = (color: string): string => {
  if (color.startsWith("var(")) {
    if (color.includes("--color-gray")) return "#b8b8b8";
    if (color.includes("--color-light-gray")) return "#d0cfcf";
    if (color.includes("--color-dark-blue")) return "#1e3c5a";
    if (color.includes("--color-blue")) return "#3d6b9c";
    if (color.includes("--color-light-blue")) return "#2a8fa6";
    if (color.includes("--color-teal")) return "#026d7a";
    if (color.includes("--color-green")) return "#1a8b60";
    if (color.includes("--color-orange")) return "#c5471a";
    if (color.includes("--color-yellow")) return "#b8750a";
    return "#d0cfcf";
  }

  if (color.startsWith("#")) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    const darkenFactor = 0.7;
    const newR = Math.floor(r * darkenFactor);
    const newG = Math.floor(g * darkenFactor);
    const newB = Math.floor(b * darkenFactor);

    return `#${newR.toString(16).padStart(2, "0")}${newG
      .toString(16)
      .padStart(2, "0")}${newB.toString(16).padStart(2, "0")}`;
  }

  return color;
};